module.exports = "\n<div>\n    <img class=\"logo centered\" [src]=\"logo | safeUrl\">\n</div>\n<h2 style=\"text-align: center\">This feature is not enabled on your account. Please contact your account representative in case you are interested in this feature.</h2>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/page-not-available/page-not-available.html
// module id = ./src/app/core/components/page-not-available/page-not-available.html
// module chunks = main